import { User } from '@img-arena/consoles-api-streaming'

import { CheckboxDeleteSelectedItem } from '../CheckboxDeleteSelectedItem'

interface CheckboxDeleteSelectedStreamingUserItemProps<T extends User> {
  onDelete: (rows: T[]) => Promise<void> | void
}

export const CheckboxDeleteSelectedStreamingUserItem = <T extends User>({
  onDelete
}: CheckboxDeleteSelectedStreamingUserItemProps<T>) => (
  <CheckboxDeleteSelectedItem
    onDelete={onDelete}
    renderItem={(row) => `${row.fullName} (${row.email})`}
    successMessage={(rows) => `${rows.length} users deleted successfully`}
    errorMessage={(rows) => `Failed to delete ${rows.length} users`}
    confirmationTitle="Delete Selected Users"
    confirmationMessage="Are you sure you want to delete the following users? This action cannot be undone."
  />
)
